'use client';
import { useRouter } from 'next/dist/client/router';
import { useSearchParams } from 'next/navigation';
import React, { type FC, useEffect } from 'react';

import { useAuth } from '../../context/AuthContext';
import { BASE_SEARCH_PATH } from '../../utils/search';
import { getStripePaymentLinkObject } from '../../utils/url';
import { SignupForm } from '../forms/SignupForm';

const SignUp: FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { currentUser, isLoadingUser } = useAuth();

  const redeemCode = searchParams.get('redeemCode') as Optional<string>;

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    if (currentUser?.applicant != null) {
      void router?.push(
        getStripePaymentLinkObject(searchParams, currentUser.email) ??
          (searchParams.get('redirect_url') as Optional<string>) ??
          BASE_SEARCH_PATH,
      );
    }
  }, [
    currentUser?.applicant,
    currentUser?.email,
    isLoadingUser,
    router,
    searchParams,
  ]);

  return <SignupForm redeemCode={redeemCode} />;
};

export default SignUp;
